export function setActiveWorkspace(draft, action) {
    if (action.payload) {
        const { workspace } = action.payload;
        draft.workspace.current = workspace;
    }
}
